import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import history from './history';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './shared/store';
import './index.css';
import {PORTAL_NAME} from './config.json';
import {ThemeProvider} from 'styled-components';
import {Tasks} from './advisor/shared/widgets';
import {AccountsTable, BalanceGraph, ExposureGraph, PerformanceGraph} from './advisor/shared/widgets/containers';
import {Button, DescriptiveText, Table} from './shared';
import axiosInstance, {setAuth, setInternalAuth} from './shared/utils/axios';
import {SWRConfig} from 'swr';
import HouseholdsTable from './advisor/shared/widgets/containers/HouseholdsTable';

const defaultTheme = {
  name: 'CircleBlack Dark',
  displayName: 'Standard Dark',
  dark: false,
  // backgroundColor: '#14171A',
  backgroundColor: 'grey',
  // tileBackgroundColor: '#252B34',
  tileBackgroundColor: 'white',
  neumorphic: true,
  primaryColor: '#00AEEF',
  secondaryColor: null,
  titleText: {
    name: 'ProximaLight',
    size: '18px',
    lineHeight: '40px',
  },
  bodyText: {
    name: 'ProximaRegular',
    size: '12px',
  },
  labelText: {
    name: 'ProximaLight',
    size: '10px',
  },
  primaryButtonText: {
    name: 'ProximaExtrabold',
  },
  secondaryButtonText: {
    name: 'ProximaLight',
  },
};

if (PORTAL_NAME === 'widgets') {
  window.CBWidgets.setAuth = setAuth;
  window.CBWidgets.setInternalAuth = setInternalAuth;
  window.CBWidgets.setTheme = theme => Object.assign(defaultTheme, theme);

  window.CBWidgets.balanceGraph = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <BalanceGraph
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.exposureGraph = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <ExposureGraph
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.descriptiveText = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <DescriptiveText
            {...params}
          />
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.button = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <Button
            {...params}
          />
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.accountsTable = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <AccountsTable
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.householdsTable = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <HouseholdsTable
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.performanceGraph = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <PerformanceGraph
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.tasks = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <SWRConfig value={{
            fetcher: url => axiosInstance.get(url).then(res => res.data),
            revalidateOnFocus: false,
            dedupingInterval: 5000,
            focusThrottleInterval: 10000,
          }}>
            <Tasks
              {...params}
            />
          </SWRConfig>
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };

  window.CBWidgets.table = (id, params, theme) => {
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme || defaultTheme}>
          <Table
            {...params}
          />
        </ThemeProvider>
      </Provider>,
      document.getElementById(id)
    );
  };
} else {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <App/>
      </Router>
    </Provider>,
    document.getElementById('circleblack-root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
